/* eslint-disable @angular-eslint/prefer-inject */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'customFormatDate',
  standalone: false
})
export class CustomFormatDatePipe implements PipeTransform {
  public culture!: string;

  public constructor(private translateService: TranslateService) { }
  public transform(value: Date): any {
    return formatDate(value, 'shortDate', this.translateService.currentLang);
  }
}
